import { cn } from "@/lib/utils";

import { GradeBadge } from "./KpiTile";
import { Card } from "./FunnelCard";
import {
  euros,
  grade,
  minutes,
  percent,
  rate,
  type Performance,
} from "./performance";

/** Fewer calls than this: the pick-up rate is not graded. */
const MIN_CALLS = 20;

/** Each person who worked leads in the period, side by side. */
export const SettersCard = ({ perf }: { perf: Performance }) => {
  const rows = perf.setters;
  return (
    <Card
      title="Equipo"
      hint="Lo que ha hecho cada uno en el periodo (llamadas, conversaciones y ventas que tiene asignadas)"
    >
      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground">
          Nadie ha llamado en el periodo.
        </p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b text-xs text-muted-foreground">
                <th className="px-2 py-1.5 text-left font-medium">Persona</th>
                <th className="px-2 py-1.5 text-right font-medium">Días</th>
                <th className="px-2 py-1.5 text-right font-medium">Llamadas</th>
                <th className="px-2 py-1.5 text-right font-medium">Por día</th>
                <th className="px-2 py-1.5 text-right font-medium">Cogidas</th>
                <th className="px-2 py-1.5 text-right font-medium">
                  Leads hablados
                </th>
                <th className="px-2 py-1.5 text-right font-medium">Ventas</th>
                <th className="px-2 py-1.5 text-right font-medium">
                  Venta / hablados
                </th>
                <th className="px-2 py-1.5 text-right font-medium">
                  Facturado
                </th>
                <th className="px-2 py-1.5 text-right font-medium">
                  1ª llamada
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => {
                const pickup = rate(row.answered, row.calls);
                const close = rate(row.sales, row.leads_talked);
                return (
                  <tr
                    key={row.id}
                    className="border-b tabular-nums last:border-0"
                  >
                    <td className="px-2 py-1.5">
                      {row.name}
                      {row.admin ? (
                        <span className="ml-1 text-xs text-muted-foreground">
                          (socio)
                        </span>
                      ) : null}
                    </td>
                    <td className="px-2 py-1.5 text-right">
                      {row.active_days}
                    </td>
                    <td className="px-2 py-1.5 text-right">{row.calls}</td>
                    <td className="px-2 py-1.5 text-right">
                      {row.active_days
                        ? Math.round(row.calls / row.active_days)
                        : "—"}
                    </td>
                    <td className="px-2 py-1.5 text-right">
                      <span className="inline-flex items-center gap-1.5">
                        {percent(pickup)}
                        {row.calls >= MIN_CALLS ? (
                          <GradeBadge value={grade("pickupRate", pickup)} />
                        ) : null}
                      </span>
                    </td>
                    <td className="px-2 py-1.5 text-right">
                      {row.leads_talked}
                      {row.whatsapp_talks ? (
                        <span className="text-xs text-muted-foreground">
                          {" "}
                          ({row.whatsapp_talks} WA)
                        </span>
                      ) : null}
                    </td>
                    <td
                      className={cn(
                        "px-2 py-1.5 text-right",
                        row.sales ? "font-semibold" : "",
                      )}
                    >
                      {row.sales}
                    </td>
                    <td className="px-2 py-1.5 text-right">
                      <span className="inline-flex items-center gap-1.5">
                        {percent(close)}
                        {row.leads_talked >= 10 ? (
                          <GradeBadge value={grade("closeTalked", close)} />
                        ) : null}
                      </span>
                    </td>
                    <td className="px-2 py-1.5 text-right">
                      {euros(row.revenue)}
                    </td>
                    <td className="px-2 py-1.5 text-right">
                      {minutes(row.first_call_median_minutes)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <p className="text-[11px] text-muted-foreground">
        «Cogidas» = % de llamadas en las que hablaron. «Venta / hablados» =
        ventas del periodo entre leads distintos con los que habló. «1ª llamada»
        = mediana de lo que tardó en llamar a los leads que llamó primero.
      </p>
    </Card>
  );
};
